export function getDirectoryLink(familyId, fullName) {
    if (familyId) {
        return `https://www.cedarparkchurchofchrist.org/members/directory/family/${familyId}`;
    }
    const query = fullName.split(" ").slice(0, 2).join(" ");
    return `https://www.cedarparkchurchofchrist.org/members/directory?q=${query}`;
}
